'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

interface AchievementNotificationContextType {
  newAchievementCount: number;
  incrementAchievementCount: () => void;
  clearAchievementCount: () => void;
}

const AchievementNotificationContext = createContext<AchievementNotificationContextType | undefined>(undefined);

export function AchievementNotificationProvider({ children }: { children: React.ReactNode }) {
  const [newAchievementCount, setNewAchievementCount] = useState(0);

  const incrementAchievementCount = useCallback(() => {
    setNewAchievementCount(prev => prev + 1);
  }, []);

  const clearAchievementCount = useCallback(() => {
    setNewAchievementCount(0);
  }, []);

  return (
    <AchievementNotificationContext.Provider value={{
      newAchievementCount,
      incrementAchievementCount,
      clearAchievementCount
    }}>
      {children}
    </AchievementNotificationContext.Provider>
  );
}

export function useAchievementNotification() {
  const context = useContext(AchievementNotificationContext);
  if (context === undefined) {
    throw new Error('useAchievementNotification must be used within an AchievementNotificationProvider');
  }
  return context;
}